import { TaggingParams } from './TaggingParams';

export const executeTagging = ({
  event,
  screenName,
  userState,
  customersState,
  type,
  filterInfo,
  itemDescription,
  itemName,
  nonInteraction,
  page,
  ecommerce,
  product,
  contratoObra,
  orderCliente,
  order,
  ...anyOtherProperty
}: TaggingParams): void => {
  try {
    const customersIds = customersState.customers.map(
      ({ customerId }: { customerId: string }) => customerId
    );

    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    const data: Record<string, unknown> = {
      event,
      screenName,
      userEmail: userState.email,
      userId: userState.id,
      userBp: customersIds.join(';'),
      type,
      ...anyOtherProperty,
      ...(itemName && { itemName }),
      ...(itemDescription && { itemDescription }),
      ...(filterInfo && { filterInfo }),
      ...(product && { product }),
      ...(nonInteraction && { nonInteraction }),
      ...(page && { page }),
      ...(orderCliente && { orderCliente }),
      ...(order && { order }),
      ...(contratoObra && { contratoObra }),
      ...(ecommerce && { ecommerce })
    };

    window.dataLayer.push(data);
  } catch (e) {
    console.error('Erro ao efetuar tageamento: ', e);
  }
};
